import { defineMessages } from 'react-intl';

export default defineMessages({
  CapitalGarantiTitle: {
    id: 'scr.capital_garanti_title',
  },
  CapitalGarantiDescription: {
    id: 'scr.capital_garanti_description',
  },
  versementsTitle: {
    id: 'scr.versements_title',
  },
  versementsDescription: {
    id: 'scr.versements_description',
  },
  primeTitle: {
    id: 'scr.Prime_title',
  },
  primeDescription: {
    id: 'scr.prime_description',
  },
  participationBenTitle: {
    id: 'scr.Participation_benifice_title',
  },
  participationBenDescription: {
    id: 'scr.Participation_benifice_description',
  },
  valeurRachatTitle: {
    id: 'scr.valeur_rachats_title',
  },
  valeurRachatDescription: {
    id: 'scr.valeur_rachats_description',
  },
  montantRachatTitle: {
    id: 'scr.montant_rachat_title',
  },
  montantRachatDescription: {
    id: 'scr.montant_rachat_description',
  },
  montantAvanceNonRembourseTitle: {
    id: 'scr.montant_avance_non_remobourse_title',
  },
  montantAvanceNonRembourseDescription: {
    id: 'scr.montant_avance_non_remobourse_description',
  },
  montantContreAssuranceTitle: {
    id: 'scr.montant_contre_assurance_title',
  },
  montantContreAssuranceDescription: {
    id: 'scr.montant_contre_assurance_description',
  },
  valeurReductionTitle: {
    id: 'scr.valeur_reduction_title',
  },
  valeurReductionDescription: {
    id: 'scr.valeur_reduction_description',
  },
});
